import { useSelector } from '@redux';
import RestShow from 'containers/rest/Show';
import React from 'react';
import { DynamicObjectType } from 'types/commons';
import ShowContent from './ShowContent';

const BannedCustomersShow = () => {
  const data = useSelector<DynamicObjectType>(
    (state) => state.bannedCustomers.currentData,
  );

  const breadcrumbs = [
    {
      title: 'common.page.customerBlacklist',
      href: '/settings/bannedCustomers',
    },
    {
      title: (
        <span className="font-bold text-sm text-[--primary]">
          {`#${data?.id}`}
        </span>
      ),
    },
  ];
  return (
    <RestShow model="bannedCustomers" breadcrumbs={breadcrumbs}>
      <ShowContent data={data} />
    </RestShow>
  );
};

export default BannedCustomersShow;
